const  VoiceService  = require('./VoiceService');
const {
	SpeechConfig,
	SpeechSynthesizer,
	SpeechSynthesisOutputFormat,
	ResultReason,
	SpeechSynthesisBoundaryType
} = require( 'microsoft-cognitiveservices-speech-sdk' );
const { Base64 } = require( 'skylar-agent/Util' );

class AzureVoiceService extends VoiceService {
	speechConfig;
	
	static voiceOptions() {
		const voiceIds = [
		"en-US-AvaMultilingualNeural4",
		"en-US-AndrewMultilingualNeural4",
		"en-US-EmmaMultilingualNeural4",
		"en-US-AlloyTurboMultilingualNeural4",
		"en-US-EchoTurboMultilingualNeural4",
		"en-US-FableTurboMultilingualNeural4",
		"en-US-OnyxTurboMultilingualNeural4",
		"en-US-NovaTurboMultilingualNeural4",
		"en-US-ShimmerTurboMultilingualNeural4",
		"en-US-BrianMultilingualNeural4",
		"en-US-AvaNeural",
		"en-US-AndrewNeural",
		"en-US-EmmaNeural",
		"en-US-BrianNeural",
		"en-US-JennyNeural",
		"en-US-GuyNeural",
		"en-US-AriaNeural",
		"en-US-DavisNeural",
		"en-US-JaneNeural",
		"en-US-JasonNeural",
		"en-US-KaiNeural",
		"en-US-LunaNeural",
		"en-US-SaraNeural",
		"en-US-TonyNeural",
		"en-US-NancyNeural",
		"en-US-CoraMultilingualNeural4",
		"en-US-ChristopherMultilingualNeural4",
		"en-US-BrandonMultilingualNeural4",
		"en-US-AmberNeural",
		"en-US-AnaNeural",
		"en-US-AshleyNeural",
		"en-US-BrandonNeural",
		"en-US-ChristopherNeural",
		"en-US-CoraNeural",
		"en-US-ElizabethNeural",
		"en-US-EricNeural",
		"en-US-JacobNeural",
		"en-US-JennyMultilingualNeural4",
		"en-US-MichelleNeural",
		"en-US-MonicaNeural",
		"en-US-RogerNeural",
		"en-US-RyanMultilingualNeural4",
		"en-US-SteffanNeural",
		"en-US-AdamMultilingualNeural1,4",
		"en-US-AIGenerate1Neural1",
		"en-US-AIGenerate2Neural1",
		"en-US-AmandaMultilingualNeural1,4",
		"en-US-AshTurboMultilingualNeural1,4",
		"en-US-BlueNeural1",
		"en-US-DavisMultilingualNeural1,4",
		"en-US-DerekMultilingualNeural1,4",
		"en-US-DustinMultilingualNeural1,4",
		"en-US-EvelynMultilingualNeural1,4",
		"en-US-LewisMultilingualNeural1,4",
		"en-US-LolaMultilingualNeural1,4",
		"en-US-NancyMultilingualNeural1,4",
		"en-US-PhoebeMultilingualNeural1,4",
		"en-US-SamuelMultilingualNeural1,4",
		"en-US-SerenaMultilingualNeural1,4",
		"en-US-SteffanMultilingualNeural1,4",
		"en-US-Adam:DragonHDLatestNeural",
		"en-US-Andrew:DragonHDLatestNeural",
		"en-US-Andrew2:DragonHDLatestNeural",
		"en-US-Ava:DragonHDLatestNeural",
		"en-US-Brian:DragonHDLatestNeural",
		"en-US-Davis:DragonHDLatestNeural",
		"en-US-Emma:DragonHDLatestNeural",
		"en-US-Emma2:DragonHDLatestNeural",
		"en-US-Steffan:DragonHDLatestNeural",
		"en-US-Alloy:DragonHDLatestNeural1",
		"en-US-Andrew3:DragonHDLatestNeural1",
		"en-US-Aria:DragonHDLatestNeural1",
		"en-US-Ava3:DragonHDLatestNeural1",
		"en-US-Bree:DragonHDLatestNeural1",
		"en-US-Jenny:DragonHDLatestNeural1",
		"en-US-MultiTalker-Ava-Andrew:DragonHDLatestNeural1",
		"en-US-MultiTalker-Ava-Steffan:DragonHDLatestNeural1",
		"en-US-Nova:DragonHDLatestNeural1",
		"en-US-Phoebe:DragonHDLatestNeural1",
		"en-US-Serena:DragonHDLatestNeural1"
		]

		return voiceIds.map( id => ({
			id,
			name: id
		}));

	}

	static voiceOptions_Orig() {
		return [
			{
				id: 'en-US-AriaNeural',
				name: 'en-US-AriaNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['chat', 'customerservice', 'narration-professional', 'newscast-casual', 'newscast-formal'],
				emotion: ['angry', 'cheerful', 'excited', 'friendly', 'hopeful', 'sad', 'shouting', 'terrified', 'unfriendly', 'whispering']
			},
			{
				id: 'en-US-JennyNeural',
				name: 'en-US-JennyNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['assistant', 'chat', 'customerservice', 'newscast', 'angry', 'cheerful', 'sad', 'excited', 'friendly', 'terrified', 'shouting', 'unfriendly', 'whispering', 'hopeful'],
				emotion: ['angry', 'cheerful', 'excited', 'friendly', 'hopeful', 'sad', 'shouting', 'terrified', 'unfriendly', 'whispering']
			},
			{
				id: 'en-US-GuyNeural',
				name: 'en-US-GuyNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['newscast', 'angry', 'cheerful', 'sad', 'excited', 'friendly', 'terrified', 'shouting', 'unfriendly', 'whispering', 'hopeful'],
				emotion: ['angry', 'cheerful', 'excited', 'friendly', 'hopeful', 'sad', 'shouting', 'terrified', 'unfriendly', 'whispering']
			},
			{
				id: 'en-US-DavisNeural',
				name: 'en-US-DavisNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['chat', 'angry', 'cheerful', 'excited', 'friendly', 'hopeful', 'sad', 'shouting', 'terrified', 'unfriendly', 'whispering'],
				emotion: ['angry', 'cheerful', 'excited', 'friendly', 'hopeful', 'sad', 'shouting', 'terrified', 'unfriendly', 'whispering']
			},
			{
				id: 'en-US-AmberNeural',
				name: 'en-US-AmberNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-AnaNeural',
				name: 'en-US-AnaNeural',
				gender: 'Female',
				age: 'Child',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-AshleyNeural',
				name: 'en-US-AshleyNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-BrandonNeural',
				name: 'en-US-BrandonNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-ChristopherNeural',
				name: 'en-US-ChristopherNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-CoraNeural',
				name: 'en-US-CoraNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-ElizabethNeural',
				name: 'en-US-ElizabethNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-EricNeural',
				name: 'en-US-EricNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-JacobNeural',
				name: 'en-US-JacobNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-JaneNeural',
				name: 'en-US-JaneNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-JasonNeural',
				name: 'en-US-JasonNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-MichelleNeural',
				name: 'en-US-MichelleNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-MonicaNeural',
				name: 'en-US-MonicaNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-NancyNeural',
				name: 'en-US-NancyNeural',
				gender: 'Female',
				age: 'Elderly',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-RogerNeural',
				name: 'en-US-RogerNeural',
				gender: 'Male',
				age: 'Elderly',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-SaraNeural',
				name: 'en-US-SaraNeural',
				gender: 'Female',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-SteffanNeural',
				name: 'en-US-SteffanNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			},
			{
				id: 'en-US-TonyNeural',
				name: 'en-US-TonyNeural',
				gender: 'Male',
				age: 'Adult',
				style: ['general'],
				emotion: ['neutral']
			}
		];
	}

	// Config prefix: VOICE_<SERVICE>_<CONFIG PROPERTY>

	/* ENV Config
		VOICE_AZURE_SUBSCRIPTION_KEY
		VOICE_AZURE_REGION
	*/
	constructor() {
		super('azure');

		const { SUBSCRIPTION_KEY, REGION } = this.config;
		const speechConfig = SpeechConfig.fromSubscription( SUBSCRIPTION_KEY, REGION );
		// https://learn.microsoft.com/en-us/javascript/api/microsoft-cognitiveservices-speech-sdk/speechsynthesisoutputformat?view=azure-node-latest
		speechConfig.speechSynthesisOutputFormat = SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3;
		speechConfig.speechSynthesisLanguage = 'en-US';
		this.speechConfig = speechConfig;
	}

	/**
	 * 
	 * @param {String} text 
	 * @param {Boolean} withTimestamps 
	 */
	async synthesizeSpeech( text, withTimestamps ) {
		const result = await this.apiRequest( text );
		return result;
	}

	async apiRequest( text ) {
		this.speechConfig.speechSynthesisVoiceName = this.voiceId;
		const synth = new SpeechSynthesizer( this.speechConfig );
		const segment = [];
		const start = [];

		let lastOffset = 0;

		synth.wordBoundary = (s, e) => {
			const nextOffset = e.textOffset + e.wordLength;
			const word = text.substr( lastOffset, nextOffset - lastOffset );
			segment.push( word );
			start.push( e.audioOffset / 10000000 );
			lastOffset = nextOffset;

		};

		return new Promise((resolve, reject) => {
			synth.speakTextAsync( text,
				result => {
					synth.close();
					if ( result.reason === ResultReason.SynthesizingAudioCompleted ) {
						const audioBuffer = Buffer.from( result.audioData );
						resolve({
							audio_base64: audioBuffer.toString('base64'),
							messagedata: { segment, start }
						});
					} else {
						reject( new Error( 'Synthesis cancelled: ' + result.errorDetails ));
					}
				},
				error => {
					synth.close();
					reject(error);
				}
			);
		});
	}
}

module.exports = AzureVoiceService;